<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
                <span >&#169; 2024 TCM Bank, N.A.  This card is issued by TCM Bank, N.A. Subject to credit approval.</span>
            </div>
            <div class="col-md-3 d-flex align-items-center footer-right justify-content-center">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 fdic-logo mx-auto" >
                <img class="img-fluid" src="/assets/image/fdic-digital-sign.svg" alt="">
            </div>
        </div>

    </div>
</footer>
